import createPersistedState from 'vuex-persistedstate';

import userData from './modules/userData'
import company from './modules/company'
import filterOptions from './modules/filterOptions'
import alert from './modules/alert'
import maps from "./modules/maps"
import productCategory from './modules/productCategory'

import { tooltipJson } from './../Options/tooltip'

//initiliase store for Vuex
const store  = {
  plugins: [
    createPersistedState({})
  ],
    state : {
      filterUrl : '',
      updateData : 0,
      lastData : null,
      modules : null,
      lastDataLateCheck : null,
      lastDataExitCheck : null,
      tooltip : tooltipJson
    },
    modules : {
      userData,
      company,
      filterOptions,
      alert,
      maps,
      productCategory
    }
};

export default store;